import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {reduxForm, formValueSelector, change} from 'redux-form';

import {
  MODALS,
  fetchPermissionEntities,
  selectPermissionNamespacedEntities,
  editTeamPermissions
} from 'ducks/teams';

import {selectModal} from 'ducks/modals';

import {TeamPermissionsForm} from 'containers/MyTeams/components/shared';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  const permissionsWithNamespace = [
    ...props.locationSpecific,
    ...props.generic
  ];
  let allPermissionEntities: Array<any> = [];
  permissionsWithNamespace.forEach(ns => {
    allPermissionEntities = [
      ...allPermissionEntities,
      ns.value.map(ent => ent.value)
    ];
  });

  // TODO: Rework these keys once the API is fixed
  const possitivePermissions = _.keys(values.permissions).filter(
    k => values.permissions[k]
  );
  const negativePermissions = _.flatten(allPermissionEntities).filter(
    ent => !possitivePermissions.includes(ent)
  );

  dispatch(
    editTeamPermissions(
      {
        possitivePermissionEntities: possitivePermissions.map(p => ({
          value: p
        })),
        negativePermissionEntities: negativePermissions.map(p => ({value: p})),
        teamId: props.teamId
      },
      props.getSubmitExtraActions()
    )
  );
};

class ManageTeamPermissionsForm extends React.Component<any> {
  componentDidMount() {
    this.props.fetchPermissionEntities();
  }

  changePermissionField = ({id, value}) => {
    this.props.change(id, value);
  };

  render() {
    const {team, locationSpecific, generic, selectedPermissions} = this.props;

    return (
      <TeamPermissionsForm
        team={team}
        locationSpecific={locationSpecific}
        generic={generic}
        selectedPermissions={selectedPermissions}
        changePermissionField={this.changePermissionField}
      />
    );
  }
}

const formSelector = formValueSelector('manageTeamPermissions');

const mapStateToProps = state => {
  const {team} = selectModal(state, MODALS.TEAM_DETAILS).data;
  const {locationSpecific, generic} = selectPermissionNamespacedEntities(state);

  const {teamPermissions} = selectModal(
    state,
    MODALS.MANAGE_TEAM_PERMISSIONS
  ).data;

  let initialPermissions = {};

  if (teamPermissions) {
    teamPermissions.permissionEntities.forEach(ent => {
      initialPermissions = {...initialPermissions, [ent.value]: true};
    });
  }

  return {
    initialValues: {permissions: initialPermissions},
    team,
    locationSpecific,
    generic,
    selectedPermissions: formSelector(state, 'permissions')
  };
};

const mapDispatchToProps = {fetchPermissionEntities, change};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'manageTeamPermissions',
    enableReinitialize: true,
    onSubmit: formSubmit
  })(ManageTeamPermissionsForm)
);
